module.exports = __webpack_public_path__ + "fonts/Roboto-Light.eceaea9a.ttf";